<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span><svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
</button>
<h2 modal-title>
    Gaat u verhuizen?
</h2>

<div modal-content class="modal-body">
    <div class="btn-group btn-group--spread">
        <button class="btn btn--secondary" (click)="newResidence()">Ik heb een extra woning</button>
        <button class="btn btn--primary" (click)="changeResidence()">
            Ja, ik ga verhuizen
        </button>
    </div>
</div>
